import styled from 'styled-components'

import { panelCss } from 'components/page/PhotoViewer/Panel/Panel.styled'
import { media } from 'components/presentational'

export const Wrapper = styled.div`
  ${panelCss};
  top: 20px;

  ${media.tablet`
    top: 10px;
  `};
`

/**
 * Для того чтобы кнопки не скакали, в зависимости от контента
 */

export const CenterWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  inset: 0;
`
